import { useState } from 'react';
import { useDyteMeeting } from '@dytesdk/react-web-core';
import {
	DyteMicToggle,
	DyteCameraToggle,
	DyteButton,
	DyteDialogManager,
	DyteLeaveButton,
	DyteSettingsToggle,
	DyteChatToggle,
	DyteSidebar,
	DyteScreenShareToggle,
} from '@dytesdk/react-ui-kit';
import FeedbackQuestionsNudge from '../feedbackQuestion/FeedbackQuestionsNudge';
import { useMeetingContext } from 'src/context/MeetingProvider';

type Props = {
	isHost: boolean;
	showEndMeetingModal: boolean;
	setShowEndMeetingModal: (showEndMeetingModal: boolean) => void;
};

const InterviewFooter = ({ isHost, setShowEndMeetingModal }: Props) => {
	const dyteMeeting = useDyteMeeting();
	const { hasAssessmentEnded, ongoingAssessDetails, meeting } = useMeetingContext();

	const [states, setStates] = useState<Record<string, boolean>>({});

	const setState = (s: any) => setStates(states => ({ ...states, ...s }));

	return (
		<div className="container mx-auto flex items-center justify-center gap-2 text-white">
			<DyteMicToggle data-testid="dyte-mic-toggle" size="lg" meeting={dyteMeeting.meeting} />
			<DyteCameraToggle data-testid="dyte-camera-toggle" size="lg" meeting={dyteMeeting.meeting} />
			<DyteScreenShareToggle data-testid="dyte-screenshare-toggle" size="lg" meeting={dyteMeeting.meeting} />
			<DyteChatToggle
				data-testid="dyte-chat-toggle"
				size="lg"
				meeting={dyteMeeting.meeting}
				onClick={() => setState({ activeSidebar: !states.activeSidebar })}
			/>
			<DyteButton className="bg-inherit text-red-500" size="lg" onClick={() => setState({ activeSettings: true })}>
				<DyteSettingsToggle data-testid="dyte-settings-toggle" size="lg" />
			</DyteButton>

			<DyteButton
				className="bg-inherit text-red-500"
				size="lg"
				onClick={() => {
					setShowEndMeetingModal(true);
					!isHost && setState({ activeLeaveConfirmation: true });
				}}
			>
				<DyteLeaveButton data-testid="dyte-leave-button" className="text-red-500" size="lg" />
			</DyteButton>

			{states.activeSidebar && (
				<div className="absolute bottom-[80px] right-1/3">
					<DyteSidebar
						states={states}
						onDyteStateUpdate={e => setState(e.detail)}
						defaultSection="chat"
						// enabledSections={['chat']}
						meeting={dyteMeeting.meeting}
						className="h-[480px] w-[320px]"
					/>
				</div>
			)}

			<DyteDialogManager
				data-testId="dyte-dialog-manager"
				meeting={dyteMeeting.meeting}
				states={states}
				onDyteStateUpdate={e => setState(e.detail)}
			/>
			<div className="absolute bottom-[100px] right-[40px]">
				{meeting?.isAIInterview || (isHost && !hasAssessmentEnded && ongoingAssessDetails) ? (
					<FeedbackQuestionsNudge />
				) : null}
			</div>
		</div>
	);
};

export default InterviewFooter;
